import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppointmentActionModalBase } from '../../shared/base/appointment-action-modal.base';

@Component({
  selector: 'app-cancel-appointment-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cancel-appointment-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './cancel-appointment-modal.component.scss',
})
export class CancelAppointmentModalComponent extends AppointmentActionModalBase {}
